import { formatDurationParts } from './formatDurationParts';
// formatDuration(90) -> "1h 30min"
export const formatDuration = (totalMinutes) => formatDurationParts(totalMinutes).join(' ');
